/** A rejected HTTP submission is distinct from losing its acknowledgement in transit. */
export class RegenerationRequestError extends Error {
  constructor(readonly status: number, readonly responseBody: string, readonly code?: string, readonly bodyParseError?: unknown) {
    super(`Regeneration request returned HTTP ${status}: ${responseBody}`);
    this.name = 'RegenerationRequestError';
  }

  get definitelyRejected() {
    // A timeout/5xx can occur after admission; keep its receipt for reconciliation.
    return [400, 401, 403, 404, 409, 422, 429].includes(this.status);
  }
}
